
@if (isReady) {
  @if (!empty) {
    <app-graph-mixed [config]="graphConfigObs"></app-graph-mixed>
  } @else {
    <div class="empty-block">
      <h3>{{'graph_inclusive.no_progress_data' | translate}}</h3>
    </div>
  }
} @else {
  @if (showLoader) {
    <div class="center spinner-container">
      <app-fake-stepper [options]="loaderOptions"></app-fake-stepper>
    </div>
  }
}
